"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var report_1 = require("@shared/types/report");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var FILE_EXTENSION = '.qrf';
(function (module) {
    module.factory('pr.portingService', [
        '$http',
        '$q',
        'pr.API_ROUTES',
        'prActiveReport',
        'rsEnvironment',
        'prOverrideTrigger',
        'pr.OVERRIDE_EVENTS',
        'prMetricsService',
        'pr.reportTypeService',
        'prSavedFiltersService',
        function (
        // @ts-ignore
        $http, 
        // @ts-ignore
        $q, 
        // @ts-ignore
        API_ROUTES, 
        // @ts-ignore
        activeReport, 
        // @ts-ignore
        env, 
        // @ts-ignore
        triggerOverrides, 
        // @ts-ignore
        OVERRIDE_EVENTS, 
        // @ts-ignore
        metricsService, 
        // @ts-ignore
        reportTypeService, 
        // @ts-ignore
        SavedFiltersService) {
            var activeSurveyId = env.get('activeSurveyId');
            function openSaveFileModal(containerDef) {
                var stringifiedContainer = JSON.stringify(containerDef);
                var filename = containerDef.description + FILE_EXTENSION;
                if (lodash_1.default.hasIn(navigator, 'msSaveBlob')) {
                    // IE/Edge have a specific API for saving files
                    var blob = new Blob([stringifiedContainer], {
                        type: 'application/json'
                    });
                    navigator.msSaveBlob(blob, filename);
                }
                else {
                    var data = 'data:text/json;charset=utf-8,';
                    data += encodeURIComponent(stringifiedContainer);
                    var node = document.createElement('a');
                    node.setAttribute('href', data);
                    node.setAttribute('download', filename);
                    document.body.appendChild(node);
                    node.click();
                    node.remove();
                }
            }
            /**
             * Saves the current report definition to a json file
             * that the user can download.
             */
            function exportReport() {
                var isThreeSixtyReport = reportTypeService.getReportType() === report_1.REPORT_TYPE.TS;
                // Filter configurations need to be kept for 360 reports.
                var getFiltersPromise = isThreeSixtyReport
                    ? new SavedFiltersService(activeSurveyId).getFilters()
                    : $q.when();
                // @ts-ignore
                // @ts-ignore
                return $q.all([getFiltersPromise, activeReport.getUpdatedContainer()]).then(function (_a) {
                    var _b;
                    var filters = _a[0], container = _a[1];
                    var containerDef = container.definition;
                    // Remove personID in order to uniformly export 360 QRF Reports.
                    if ((_b = containerDef.contextMeta) === null || _b === void 0 ? void 0 : _b.bulkFieldOptions) {
                        containerDef.contextMeta.bulkFieldOptions.value = null;
                    }
                    var exportContext = {
                        activeSurveyId: activeSurveyId,
                        date: new Date(),
                        sourceContainer: containerDef._id
                    };
                    if (filters) {
                        lodash_1.default.assign(exportContext, {
                            filters: filters
                        });
                    }
                    containerDef.contextMeta.ReportImport = {
                        exportContext: exportContext
                    };
                    openSaveFileModal(containerDef);
                    metricsService.exportComplete(FILE_EXTENSION.slice(1));
                });
            }
            /**
             * Creates a new report based on the given container definition
             * @param  {object} containerDef
             * @param  {object} sourceMap - a map from sourceId to sourceId to update the sources for each widget
             * @return {object} - if successful, returns object with following properties
             *   @property {object} container - definition of new container
             *   @property {Number} widgetStates - number of widgets in new container
             */
            function importReport(containerDef, sourceMap) {
                if (!containerDef) {
                    console.error('No container provided');
                    // @ts-ignore
                    return;
                }
                return triggerOverrides({
                    event: OVERRIDE_EVENTS.NEW_CONTAINER_DEFINITION,
                    data: containerDef
                }).then(function (newContainerDef) {
                    return $http.post(API_ROUTES.IMPORT + activeSurveyId, {
                        containerDef: newContainerDef,
                        sourceMap: sourceMap || {}
                    });
                }).then(function (response) {
                    return response.data;
                });
            }
            return {
                FILE_EXTENSION: FILE_EXTENSION,
                exportReport: exportReport,
                importReport: importReport
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
